import { useEffect } from 'react'

const useClickOutside = (ref, handler) => {
  const handleEscape = (e) => {
    e = e || window.event
    if (e.keyCode === 27) {
      handler()
    }
  }

  useEffect(() => {
    const listener = (event) => {
      const element = ref ? ref.current : null
      if (!element || element.contains(event.target)) {
        return false
      }
      handler(event)
    }

    document.addEventListener(`mousedown`, listener)
    document.addEventListener(`touchstart`, listener)
    window.addEventListener('keydown', handleEscape)

    return () => {
      document.removeEventListener(`mousedown`, listener)
      document.removeEventListener(`touchstart`, listener)
      window.removeEventListener('keydown', handleEscape)
    }
  }, [ref, handler])
}

export { useClickOutside }
